type ExperienceWithImage = {
  image: string;
};

function getNormalizedImageName(image: string) {
  const imagePath = image.split("?")[0] ?? "";
  const segments = imagePath.split("/");
  const fileName = segments[segments.length - 1] ?? "";
  const normalizedFileName = fileName.trim().toLocaleLowerCase("pt-BR");
  const match = normalizedFileName.match(
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}-(.+)$/i,
  );

  return match?.[1] ?? normalizedFileName;
}

function getExperiencePriority(imageName: string) {
  if (imageName === "cazetv.png") return 0;
  if (imageName === "adidas.png") return 1;
  return 2;
}

export function compareExperiencesByPriority(
  a: ExperienceWithImage,
  b: ExperienceWithImage,
) {
  const normalizedImageNameA = getNormalizedImageName(a.image);
  const normalizedImageNameB = getNormalizedImageName(b.image);
  const priorityA = getExperiencePriority(normalizedImageNameA);
  const priorityB = getExperiencePriority(normalizedImageNameB);

  if (priorityA !== priorityB) {
    return priorityA - priorityB;
  }

  return normalizedImageNameA.localeCompare(normalizedImageNameB, "pt-BR");
}
